import { API_ROUTES } from "../config/baseURL";
import apiClient from "./apiClient";

const authApi = {
  login: async (email, password) => {
    try {
      const res = await apiClient.post(API_ROUTES.login, { email, password });
      
      if (!res.data?.success) {
        throw new Error(res.data?.message || "Login fallido");
      }

      return {
        token: res.data.data.access_token,
        user: res.data.data.user
      };
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        err.response?.data?.error ||
        (err.response?.status === 401 ? "Usuario o contraseña incorrectos" : null) ||
        err.message ||
        "Usuario o contraseña incorrectos";
      const customErr = new Error(msg);
      customErr.response = err.response;
      throw customErr;
    }
  },

  logout: async () => {
    try {
      await apiClient.post(API_ROUTES.logout, { logout: true });
    } catch (e) {
      console.error("[authApi] Error en logout:", e);
    }
  },

  refresh: async () => {
    // El refresh ahora lo maneja el interceptor de apiClient, 
    // pero mantenemos este método por si el AuthContext lo requiere manualmente
    const res = await apiClient.post(API_ROUTES.refresh);
    
    if (!res.data?.success) return null;

    return {
      token: res.data.data?.access_token ?? null,
      user: res.data.data?.user ?? null
    };
  },

  // Mantener getUserData por compatibilidad si se usa
  getUserData: async () => {
    const res = await apiClient.get(API_ROUTES.me);
    return res.data.data;
  },
};

export default authApi;
